export default __webpack_public_path__ + "static/emptyWallet-7ae84c6be95a37e66ccd414996a22ae9.jpeg";